module.exports = __webpack_public_path__ + "img/max-person-deny.b0306ccd.svg";